<template>
  <fieldset class="rate">
    <template v-for="star in stars" v-bind:key="star.id">
      <input v-model="rating" type="radio" :id="star.id" name="rating" :value="star.value" @change="handleRating" />
      <label :class="star.class" :for="star.id"></label>
    </template>
  </fieldset>
</template>

<script >
import RateServices from '../../../../../../../services/RateServices/RateServices';
import { defineComponent } from 'vue';
import cookies from '../../../../../../../components/utils/cookies';


export default defineComponent({

  name: "rating-stars",
  props: {
    mediaId: {
      type: Number,
      required: true
    },
    mediaType: {
      type: String
    }
  },
  data() {
    return {
      stars: [],
      rating: 0
    }
  },

  methods: {
    handleRating() {
      if (this.mediaId) {
        const params = {
          mediaId: this.mediaId,
          user: cookies.cookiesUserId(),
          vote: this.rating,
          typeMedia: this.mediaType
        };
        RateServices.postVideoRating(params);
      }
    }
  },

  created() {
    for (let i = 5; i > 0; i -= 0.5) {
      const star = {
        id: 'star-' + i,
        value: i,
        class: i % 1 === 0 ? 'full' : 'half'
      };
      this.stars.push(star);
    }
  },
  mounted() {
    if (this.mediaId) {
      RateServices.getVideoRating({ mediaId: this.mediaId }).then((response) => {
        this.rating = Math.round(response.data.data.average_vote * 2) / 2;
      })
    }

  }

})
</script>

<style>
@import "./RatingStars.css";

fieldset {
  padding: 0;
}

.rate {
  display: inline-block;
  border: 0;
}

.rate>input {
  display: none;
}

.rate>label {
  float: right;
}

.rate>label:before {
  display: inline-block;
  font-size: 1.25rem;
  padding: .3rem .2rem;
  margin: 0;
  cursor: pointer;
  font-family: FontAwesome;
  content: "\f005 ";
}

.rate .half:before {
  content: "\f089 ";
  position: absolute;
  padding-right: 0;
}

input:checked~label,
label:hover,
label:hover~label {
  color: var(--vm-color-two-06);
}

input:checked+label:hover,
input:checked~label:hover,
input:checked~label:hover~label,
label:hover~input:checked~label {
  color: var(--vm-color-two-06);
}

@media screen and (max-width: 576px) {
  .rate>label:before {
    font-size: 3vw;
  }

}
</style>
